import React from 'react'
import _ from 'lodash'

function CeaInfo (props) {
  const { cea, fields } = props

  const defaultFields = ['cartaDePorteAutomotor', 'cereal', 'cerealVariedad', 'calificacionCereal', 'exportador',
    'camion', 'chofer', 'turnoDeSalida', 'pesoBrutoOrigen', 'pesoTaraOrigen', 'pesoNetoOrigen', 'calificacion']

  const strongFields = ['cereal']

  const renderField = ({ field, value, cereal, key }) => {
    const style = strongFields.includes(field) ? 'info-cpa-strong' : null

    return (
      <div
        key={key}
        className={`info-cpa-column ${style}-${cereal.toLowerCase()}`}
      >
        <div className='info-cpa-label'> {_.startCase(field)} </div>
        <div className={`info-cpa-value`}> {value} </div>
      </div>
    )
  }

  const renderFields = (cea, fields = null) => {
    fields = fields || defaultFields
    return (
      <div className='info-cpa-row'>
        {
          fields.filter(field => cea[field])
            .map((field, key) => {
              return renderField({ field, value: cea[field], cereal: cea.cereal, key })
            })
        }
      </div>
    )
  }

  return (
    <div className='show-cpa-info'>
      {renderFields(cea, fields)}
    </div>
  )
}

export default CeaInfo
